export default __webpack_public_path__ + "static/media/culture-stamp-inactive.ddaafba6.png";